<template>
  <div>
    <div class="shadow-card">
      <div class="row">
        <div class="col-6">
          <img
            :style="{ height: '200px' }"
            :src="getFullImageUrl(quiz.quiz_attach)"
            class="article-image"
            alt="quiz_image"
          />
        </div>
        <div class="col-6">
          <p>{{ quiz.quiz_title }}</p>
          <p>
            <span v-html="getLimitedDescription(quiz.quiz_description)"></span>
          </p>
          <p>This quiz has been taken {{ quiz.no_of_attempts }} times.</p>
          <div class="d-flex">
            <a
              @click="() => $refs.sharePostModal.show(quiz, 1)"
              :style="{ color: getPrimaryColor() }"
              ><i
                :style="{ color: getPrimaryColor() }"
                class="fa fa-share-alt"
                aria-hidden="true"
              ></i>
              SHARE</a
            >
            <a-button
              @click="showResource(quiz, TYPES.QUIZ)"
              class="dovemed-button font-white ml-4"
              :style="{ background: getPrimaryColor() }"
              >START QUIZ</a-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuizTabView",
  props: {
    quizData: Object
  },
  data() {
    return {
      quiz: null
    };
  },

  created() {
    this.quiz = this.quizData;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/home/resources/previews/QuizCard.vue